export default {
  namespaced: true,
  state: () => ({
    supplierTransactions: {}, // key: supplierId, value: array of transactions
    loading: false,
    error: null,
  }),

  getters: {
    // Get all transactions for a supplier safely
    getTransactionsBySupplier: (state) => (supplierId) => {
      const txs = state.supplierTransactions?.[supplierId];
      return Array.isArray(txs) ? txs : [];
    },

    totalTransactions: (state, getters) => (supplierId) => {
      return getters.getTransactionsBySupplier(supplierId).length;
    },

    activeTransactions: (state, getters) => (supplierId) => {
      return getters.getTransactionsBySupplier(supplierId).filter(t => (t?.status || '').toLowerCase() === 'paid');
    },

    pendingTransactions: (state, getters) => (supplierId) => {
      return getters.getTransactionsBySupplier(supplierId).filter(t => (t?.status || '').toLowerCase() === 'pending');
    },

    getTransactionById: (state, getters) => (supplierId, transactionId) => {
      return getters.getTransactionsBySupplier(supplierId).find(t => t?.id === transactionId) || null;
    },
  },

  mutations: {
    setSupplierTransactions(state, { supplierId, transactions }) {
      if (!supplierId) return;
      state.supplierTransactions = {
        ...state.supplierTransactions,
        [supplierId]: Array.isArray(transactions) ? transactions : [],
      };
    },

    addTransaction(state, { supplierId, transaction }) {
      if (!supplierId || !transaction) return;
      if (!Array.isArray(state.supplierTransactions[supplierId])) {
        state.supplierTransactions[supplierId] = [];
      }
      state.supplierTransactions[supplierId].push({ ...transaction, id: transaction.id ?? Date.now() });
    },

    updateTransaction(state, { supplierId, transaction }) {
      if (!supplierId || !transaction) return;
      const txs = state.supplierTransactions[supplierId] || [];
      const index = txs.findIndex(t => t?.id === transaction.id);
      if (index !== -1) txs.splice(index, 1, { ...transaction });
      state.supplierTransactions[supplierId] = txs;
    },

    removeTransaction(state, { supplierId, transactionId }) {
      if (!supplierId || transactionId == null) return;
      state.supplierTransactions[supplierId] = (state.supplierTransactions[supplierId] || []).filter(t => t?.id !== transactionId);
    },

    setLoading(state, loading = false) {
      state.loading = !!loading;
    },

    setError(state, error = null) {
      state.error = error || null;
    },
  },

  actions: {
    async fetchBySupplier({ commit }, supplierId) {
      if (!supplierId) return;
      commit('setLoading', true);
      commit('setError', null);
      try {
        // Simulated API call - replace with actual fetch
        const data = await new Promise((resolve) =>
          setTimeout(() => resolve([
            { id: 1, reference: 'TX001', amount: 1200, status: 'paid', date: '2025-11-01', notes: '' },
            { id: 2, reference: 'TX002', amount: 500, status: 'pending', date: '2025-11-05', notes: '' },
          ]), 500)
        );
        commit('setSupplierTransactions', { supplierId, transactions: data });
      } catch (err) {
        commit('setError', err?.message || 'Failed to fetch transactions');
      } finally {
        commit('setLoading', false);
      }
    },

    async addTransactionAction({ commit }, { supplierId, transaction }) {
      if (!supplierId || !transaction) return;
      const txWithId = { ...transaction, id: transaction.id ?? Date.now() };
      commit('addTransaction', { supplierId, transaction: txWithId });
    },

    async updateTransactionAction({ commit }, { supplierId, transaction }) {
      if (!supplierId || !transaction) return;
      commit('updateTransaction', { supplierId, transaction });
    },

    async deleteTransaction({ commit }, { supplierId, transactionId }) {
      if (!supplierId || transactionId == null) return;
      commit('removeTransaction', { supplierId, transactionId });
    },
  },
};
